import React, { useEffect, useState } from "react";

function diff(target) {
  const t = new Date(target).getTime() - Date.now();
  if (isNaN(t)) return { d: 0, h: 0, m: 0, s: 0, done: true };
  if (t <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
  const d = Math.floor(t / 86400000);
  const h = Math.floor((t % 86400000) / 3600000);
  const m = Math.floor((t % 3600000) / 60000);
  const s = Math.floor((t % 60000) / 1000);
  return { d, h, m, s, done: false };
}

export default function CountdownTimer({ target, accent = "#1A1A1A" }) {
  const [t, setT] = useState(diff(target));
  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (t.done) {
    return <div data-testid="countdown-done" className="text-sm tracking-[0.25em] uppercase" style={{ color: accent }}>The celebration has begun</div>;
  }

  const Cell = ({ v, l }) => (
    <div className="flex flex-col items-center px-3 sm:px-5">
      <span style={{ fontFamily: "'Cormorant Garamond', serif", color: accent }} className="text-5xl sm:text-6xl lg:text-7xl font-light leading-none tabular-nums">
        {String(v).padStart(2, "0")}
      </span>
      <span className="mt-3 text-[10px] tracking-[0.3em] uppercase text-neutral-600">{l}</span>
    </div>
  );

  return (
    <div data-testid="countdown-timer" className="flex items-start justify-center divide-x divide-black/10">
      <Cell v={t.d} l="Days" />
      <Cell v={t.h} l="Hours" />
      <Cell v={t.m} l="Minutes" />
      <Cell v={t.s} l="Seconds" />
    </div>
  );
}
